// Mock data for RentMatez PG Management Application

export const features = [
  {
    id: 1,
    title: "Rent Collection & Payment Tracking",
    description: "Automated rent collection with SMS/email reminders. Track payment history and generate receipts instantly.",
    icon: "CreditCard",
    benefits: ["Automated reminders", "Digital receipts", "Payment history"]
  },
  {
    id: 2,
    title: "Tenant Management & Onboarding",
    description: "Streamlined tenant registration with document verification and digital agreements.",
    icon: "Users",
    benefits: ["Digital onboarding", "Document storage", "Agreement management"]
  },
  {
    id: 3,
    title: "Maintenance Request Handling",
    description: "Efficient complaint management system with priority tracking and resolution timeline.",
    icon: "Settings",
    benefits: ["Priority tracking", "Photo attachments", "Resolution timeline"]
  },
  {
    id: 4,
    title: "Room Booking & Availability",
    description: "Real-time room availability tracking with instant booking confirmations and occupancy management.",
    icon: "Home",
    benefits: ["Real-time updates", "Instant booking", "Occupancy tracking"]
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "₹25",
    period: "/month per tenant",
    description: "Perfect for small PG owners.",
    features: [
     "Unlimited rooms",
      "Multi-location management",
      "Dedicated account manager",
      "24/7 phone support",
      "Optinal- Digital KYC",
    ],
    popular: false
  },
  {
    id: 2,
    name: "Professional",
    price: "₹20",
    period: "/month per tenant",
    description: "Ideal for medium-sized PG operations with up to 100 tenants",
    features: [
      "Unlimited rooms",
      "Multi-location management",
      "Dedicated account manager",
      "24/7 phone support",
      "Optinal- Digital KYC",
    ],
    popular: true
  },
  {
    id: 3,
    name: "Enterprise",
    price: "₹Call for..",
    period: "...",
    description: "Comprehensive solution for large PG chains with more than 500 tenants",
    features: [
     "Unlimited rooms",
      "Multi-location management",
      "Dedicated account manager",
      "24/7 phone support",
      "Optinal- Digital KYC",
    ],
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    role: "PG Owner, Mumbai",
    content: "RentMatez transformed my PG management completely. Rent collection is now automated and I save 10 hours every month!",
    rating: 5
  },
  {
    id: 2,
    name: "Pratik ***",
    role: "PG Chain Owner, Nashik",
    content: "Managing 5 PG locations was chaotic until RentMatez. Now everything is centralized and efficient.",
    rating: 5
  },
  {
    id: 3,
    name: "Amol Danej",
    role: "PG Owner, Nashik",
    content: "The maintenance tracking feature is amazing. Tenants can raise complaints and I can track resolution status easily.",
    rating: 5
  }
];

export const stats = [
  {
    number: "90+",
    label: "PG Owners Trust Us"
  },
  {
    number: "15,00+",
    label: "Rooms Managed"
  },
  {
    number: "500+",
    label: "Tenants Served"
  },
  {
    number: "98%",
    label: "Customer Satisfaction"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How does RentMatez help with rent collection?",
    answer: "Our automated system sends payment reminders via SMS and email, tracks due dates, and generates digital receipts instantly upon payment."
  },
  {
    id: 2,
    question: "Can I manage multiple PG locations?",
    answer: "Yes! Our Professional and Enterprise plans support multi-location management with centralized dashboard and reporting."
  },
  {
    id: 3,
    question: "Is there a mobile app for tenants?",
    answer: "Yes, we provide a mobile app for tenants to pay rent, raise complaints, and access important notices."
  },
  {
    id: 4,
    question: "What kind of support do you provide?",
    answer: "We offer email support for Starter plans, priority support for Professional plans, and dedicated account manager with 24/7 phone support for Enterprise plans."
  },
  {
    id: 5,
    question: "Can I try the software before purchasing?",
    answer: "Absolutely! We offer a 14-day free trial with full access to all features. No credit card required."
  }
];

export const contactInfo = {
  email: "info@smartrentmate.com",
  phone: "+91-8237712346",
  address: "Nashik City, Maharashtra",
  website: "rentmatez.com"
};